import { StatusType } from './constants';
import { AvailabilitySocketMessageType } from '../socket/types';
import useAvailabilitySocket from '../socket/useAvailabilitySocket';
import useAvailabilityUserApiService from './shared/hooks/useAvailabilityUserApiService';

const useAvailabilityUserService = () => {
  const { sendMessage } = useAvailabilitySocket();
  const apiService = useAvailabilityUserApiService();

  const updateCurrentAvailabilityUserStatus = async (status: StatusType): Promise<StatusType> => {
    await sendMessage(AvailabilitySocketMessageType.ChangeUserStatus, { status });

    return status;
  };

  return {
    ...apiService,
    updateCurrentAvailabilityUserStatus,
  };
};

export default useAvailabilityUserService;
